export function isEmpty(value){
  if(value == null || typeof value === 'undefined' || value === '') return true
  else return false
}